(function($) {


    $(document).ready(function(){
        
        $('#property-map-view').click(function (e) {
            e.preventDefault();
            if($(this).hasClass('off')) {
                $(this).toggleClass('off');
                $('#property-list-view').toggleClass('off');
                $('#property-cards').hide();
                $('#sort-select').hide();
                $('#property-map').show();
            }
        });
        $('#property-list-view').click(function (e) {
            e.preventDefault();
            console.log("List");
            if($(this).hasClass('off')) {
                $(this).toggleClass('off');
                $('#property-map-view').toggleClass('off');
                $('#property-map').hide();
                $('#sort-select').show();
                $('#property-cards').show();
            }
        });
        $('#videoModal').on('hidden.bs.modal', function (e) {
            $('#videoModal iframe').attr('src', '');
        });

        


    });

    
}(jQuery));
